export default function Checkbox(props: {
  text: string;
  setValue: (val: boolean) => void;
  id: string;
}) {
  const { text, setValue, id } = props;

  return (
    <div className="mb-4 flex items-center">
      <input
        id={id}
        type="checkbox"
        value=""
        className="h-4 w-4 rounded border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-blue-600"
        onChange={(val) => setValue(val.target.checked)}
      />
      <label
        htmlFor="default-checkbox"
        className="text-resp-base ms-2 font-medium"
      >
        {text}
      </label>
    </div>
  );
}
